import {PreviewDto} from '../../common/shared/api/nicolas/vo/PreviewDto.interface';
import {Preview} from '../generated/types';
import {createSingle} from './Single';

export function createPreview({
  item,
  next_item,
  using_scroll,
}: PreviewDto): Preview {
  return {
    item: createSingle(item),
    nextItem: next_item ? createSingle(next_item) : undefined,
    usingScroll: using_scroll,
  };
}
